import React from 'react';
import { appDocumentTitle } from '../../appMeta';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageShell } from '../../layout/PageShell';
import { WorkOrderListTabScreen } from './TabScreens/List';

export function SamplingWorkOrdersPage() {
  useDocumentTitle(appDocumentTitle('Work order'));

  return (
    <PageShell title="Work order" subtitle="Daftar work order dari quotation.">
      <WorkOrderListTabScreen />
    </PageShell>
  );
}

export { WorkOrderDetailRoute } from './WorkOrderDetailRoute';
export { WorkOrderEditRoute } from './WorkOrderEditRoute';
export { WorkOrderSampleCreateRoute } from './WorkOrderSampleCreateRoute';
